const enterpriseCodeRouter = [
  {
    path: '/enterpriseCodeAuth',
    name: 'EnterpriseCodeAuth',
    meta: { title: '实名认证' },
    component: () => import('@/views/enterpriseCodeAuth/index.vue')
  },
  {
    path: '/enterpriseCodeAuthMethod',
    name: 'EnterpriseCodeAuthMethod',
    meta: { title: '认证方式' },
    component: () => import('@/views/enterpriseCodeAuth/method.vue')
  }
]

export default enterpriseCodeRouter
